import { utils } from '@digital-commerce/shared-utils'
import {
  allPass,
  pipe,
  complement,
  pathOr,
  filter,
  path,
  isEmpty,
  propEq,
  values,
  reject,
  prop,
  includes
} from 'ramda'
import { getItemWithTags } from '../../../../utils/cart'
import {
  buildSubItemsList,
  getIncludedHardware,
  isSecurityItem,
  getSecurityService
} from '../SmartHomeSecurity/utils'

const { isBusinessCart, getMonthlyItemPrice, findMonthlyRecurring } = utils.cart

export const BUSINESS_CHANGE_URL = '/business/small/security/security-systems?linktype=ge-mainnav'

export const hasSecureBusiness = (service, cart) => {
  if (!service || !isBusinessCart(cart)) return false
  if (!isSecurityItem(service)) return false
  return true
}

export const buildSBSIncludedDevicesList = (service, lang) => {
  return buildSubItemsList(getIncludedHardware(service), lang)
}

/**
 * Extract all additional devices from a module service
 * @param {ModuleService} service
 * @returns {CartItem[]} List with additional devices
 */
const getAdditionalHardware = (service) =>
  pipe(
    pathOr([], ['items']),
    getItemWithTags(['hardware']),
    filter((item) => getMonthlyItemPrice(item).amount > 0)
  )(service)

const getMonthlyAdditionalDevices = pipe(
  getAdditionalHardware,
  filter(
    pipe(
      path(['itemPrice', 'recurring']),
      findMonthlyRecurring,
      allPass([
        complement(isEmpty),
        complement(propEq('recurringDuration', 1)),
        complement(propEq('amount', 0))
      ])
    )
  )
)

export const buildSBSAdditionalDevicesList = (service, lang) => {
  return buildSubItemsList(getMonthlyAdditionalDevices(service), lang)
}

const getAdditionalChargesWithoutInstallFee = pipe(
  prop(['items']),
  getItemWithTags(['security', 'fee']),
  values,
  reject(pipe(prop('tags'), includes('installation-fee')))
)

export const buildSBSAdditionalChargesList = (cart, lang) => {
  return buildSubItemsList(getAdditionalChargesWithoutInstallFee(cart), lang, false, false)
}

export const shouldRender = (cart) => {
  const securityService = getSecurityService(cart)
  return hasSecureBusiness(securityService, cart)
}
